module.exports = __webpack_public_path__ + "4d219121fd0914415b9572a64968f332.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/small_170x170_icon.png
// module id = 759
// module chunks = 0